import React, { useCallback, useEffect, useMemo } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultMST3050_R01Filter, MST3050_R01Filter, useMST3050_R01Store } from 'src/containers/mes/MST/MST3050_R01/Store_MST3050_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deleteMST3050_R01, downloadExcel_MST3050_R01, getMST3050_R01AllCount, getMST3050_R01DetailList, getMST3050_R01List, getPdfBlob_MST3050_R01, patchMST3050_R01 } from "./Api_MST3050_R01";
import { defaultMST3050_R01DetailDto, defaultMST3050_R01HeaderDto, MST3050_R01DetailDto, MST3050_R01Dto, MST3050_R01HeaderDto } from './Dto_MST3050_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { validateString } from 'src/utils/string/stringUtil';
import { useQzPrint } from 'src/hooks/useQzPrint';
import qz from 'qz-tray';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import { buildCommonCodeRequirements, MST3050_R01_DETAIL_ROW_VALIDATE } from 'src/utils/commonCode/commonCodeRequirementConfig';

interface Props {
	gridRef: React.RefObject<AgGridReact<MST3050_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<MST3050_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_MST3050_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { layerList, compCdList } = useCommonCodeStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	
	const {
		MST3050_R01Filter, setMST3050_R01Filter,
		MST3050_R01PastFilter, setMST3050_R01PastFilter,
		MST3050_R01List, setMST3050_R01List,
		editMST3050_R01, setEditMST3050_R01,
		selectedMST3050_R01, setSelectedMST3050_R01, 
		deletedMST3050_R01DetailList, setDeletedMST3050_R01DetailList, addDeletedMST3050_R01DetailList, removeDeletedMST3050_R01DetailList, 
		selectedMST3050_R01DetailList, setSelectedMST3050_R01DetailList, addSelectedMST3050_R01DetailList, removeSelectedMST3050_R01DetailList,
		MST3050_R01DetailList, setMST3050_R01DetailList, insertMST3050_R01DetailList,
		editMST3050_R01Detail, setEditMST3050_R01Detail,
		originalMST3050_R01DetailList, setOriginalMST3050_R01DetailList,
		allCount, setAllCount,
		initData,
		detailFetchTrigger, setDetailFetchTrigger,
		setScrollTop,
		setDetailScrollTop,
	} = useMST3050_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { printPdfFromBlob } = useQzPrint();

	useFetchActionbarAuth("MST3050_R01");

	const handlePrintClick = useCallback(async () => {
		if (!selectedMST3050_R01 || !selectedMST3050_R01.itemCd) {
				showWarning("출력할 품목정보를 선택하세요.");
				setMessage("출력할 품목정보를 선택하세요.");
				return;
			}
			setLoadingSpinner(true);
			try {
				const blob = await getPdfBlob_MST3050_R01(selectedMST3050_R01.itemCd);
				if (qz.websocket.isActive()) {
					const ok = await printPdfFromBlob(blob, "report1");
					if (ok) {
						showSuccess("PDF 출력을 완료하였습니다.");
					} else {
						const fileURL = URL.createObjectURL(blob);
						window.open(fileURL, "_blank");
						setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
					}
				} else {
					const fileURL = URL.createObjectURL(blob);
					window.open(fileURL, "_blank");
					setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
					showSuccess("PDF를 새 탭에서 열었습니다.");
				}
			} catch (error) {
				setMessage("PDF 출력 중 오류가 발생했습니다.");
			} finally {
				setLoadingSpinner(false);
			}
	}, [selectedMST3050_R01, printPdfFromBlob, setLoadingSpinner, setMessage]);
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedMST3050_R01) {
			showWarning("선택된 품목정보가 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_MST3050_R01('', selectedMST3050_R01.itemCd, MST3050_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '실장좌표정보 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedMST3050_R01])

	const getParams = (filter: MST3050_R01Filter) => {
		const params: Partial<MST3050_R01Filter> = {
			brandCd: filter.brandCd || undefined,
			itemGroup: filter.itemGroup || undefined,
			itemCd: filter.itemCd || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getMST3050_R01AllCount(getParams(MST3050_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [MST3050_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);
		setScrollTop(null);
		setDetailScrollTop(null);
	
		const responseData = (await getMST3050_R01List(
			'search',
			getParams(MST3050_R01Filter),
			MST3050_R01List.length ?? 0
		));


		let newList = [...responseData.data.data ] as MST3050_R01HeaderDto[];
		setMST3050_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedMST3050_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedMST3050_R01?.salBillNo)
			);
			setMST3050_R01PastFilter(MST3050_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedMST3050_R01(undefined);
			setMST3050_R01List([]);
			setMST3050_R01DetailList([]); 
			setDeletedMST3050_R01DetailList([]);
			setSelectedMST3050_R01DetailList([]);
			setOriginalMST3050_R01DetailList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [MST3050_R01Filter, MST3050_R01List, setMST3050_R01List, setMST3050_R01PastFilter, setSelectedMST3050_R01, selectedMST3050_R01, setScrollTop, setDetailScrollTop])

	

	//신규 행 추가시 기본적으로 세팅할 데이터를 정하고 생성
	const defaultMST3050_R01DetailRow = useCallback(() => {

		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(MST3050_R01_DETAIL_ROW_VALIDATE, {
				layerList,
			}),
		);
		if (!commonResult.valid) { return { ...defaultMST3050_R01DetailDto }; }

		return {
			...defaultMST3050_R01DetailDto,
			inserted: true,
			topBottom: layerList[0]?.minorCd || '',
		}
	}, [defaultMST3050_R01DetailDto]);
	
	
	const fetchDetailList = useCallback(async (itemCd: string) => {
		const responseData = (await getMST3050_R01DetailList(itemCd)).data.data;
		if(responseData && responseData.length > 0){
			setMST3050_R01DetailList(
				responseData.map((value: any, idx: any) => ({
					...value,
					valueIndex: value.valueIndex ?? idx + 1,
					orderIndex: value.orderIndex ?? idx + 1,
					orderIndexSeq: value.orderIndexSeq ?? 0,
				})
			));
			setOriginalMST3050_R01DetailList(responseData);
			setMessage(`${selectedMST3050_R01?.itemNm}의 실장좌표정보 ${responseData.length}건을 조회하였습니다.`);
			setTimeout(() => setMessage(""), 5000);
		}else{
			setMST3050_R01DetailList([]);
			// 행추가 안함
			// insertMST3050_R01DetailList([{ ...defaultMST3050_R01DetailRow, orderIndex: responseData.length + 1, orderIndexSeq: 0, inserted: true }]);
		}
	}, [selectedMST3050_R01, MST3050_R01DetailList])
	
	const initContainerData = useCallback(() => {
		initData();
		removeDeletedMST3050_R01DetailList();
		removeSelectedMST3050_R01DetailList();
		setEditMST3050_R01({
			...defaultMST3050_R01HeaderDto,
		})
	}, [compCdList, selectedMST3050_R01])

	const handleDeleteClick = useCallback(() => {

		if (deletedMST3050_R01DetailList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedMST3050_R01DetailList(deletedMST3050_R01DetailList);
			removeSelectedMST3050_R01DetailList();
			setMST3050_R01DetailList([...MST3050_R01DetailList]);
		} else if (selectedMST3050_R01DetailList.length > 0) {
			addDeletedMST3050_R01DetailList(selectedMST3050_R01DetailList);
			removeSelectedMST3050_R01DetailList(selectedMST3050_R01DetailList);
		}
	}, [selectedMST3050_R01DetailList, 
		deletedMST3050_R01DetailList,
		addDeletedMST3050_R01DetailList,
		removeDeletedMST3050_R01DetailList,
		removeSelectedMST3050_R01DetailList,
		setMST3050_R01DetailList,
		MST3050_R01DetailList]);
	
	const handleCreateClick = () => {
		setSelectedMST3050_R01(undefined);
		setEditMST3050_R01({
			...defaultMST3050_R01HeaderDto
		})
		setMST3050_R01DetailList([{...defaultMST3050_R01DetailDto, inserted: true}]);
		setDeletedMST3050_R01DetailList([]);
		setSelectedMST3050_R01DetailList([]);
		setOriginalMST3050_R01DetailList([]);
	}

	const validateInsertData = (header: MST3050_R01HeaderDto, detailList: MST3050_R01DetailDto[]) => {

		if(!validateString(header.itemCd)) {
			showWarning('품목코드가 없습니다.');
			return false;
		}

		const deletedDetailListToString = deletedMST3050_R01DetailList.map(value => value.toString());
		const activeDetailList = detailList.filter(detail => 
			!deletedDetailListToString.includes(detail.valueIndex.toString()) &&
			detail.isModified === true
		);

		// 1. 필수 값 유효성 검사
		for (const detail of activeDetailList) {
			if(!validateString(detail.coordinateCd)) {
				showWarning('로케이션을 선택하세요.');
				return false;
			}
			if(!validateString(detail.coordinateNm)) {
				showWarning('로케이션명을 입력하세요.');
				return false;
			}
			if(!validateString(detail.childItemcd)) {
				showWarning('실장품목을 선택하세요.');
				return false;
			}
			if(!detail.coordinateUsage && detail.coordinateUsage <= 0) {
				showWarning('수량을 입력하세요.');
				return false;
			}
		}

		return true;
	}

	const setInfoDetailList = useCallback((header: MST3050_R01HeaderDto, detailList: MST3050_R01DetailDto[]) => {
		
		return detailList.map((value, idx) => ({
			...value,
			itemCd: header.itemCd,
		}))
	}, [setMST3050_R01DetailList])
	
	const handleSaveClick = useCallback(async () => {

		let valid = true;
		if(!validateInsertData(selectedMST3050_R01!, MST3050_R01DetailList)) valid = false;
		if(!valid) { return; }
		
		const deletedMST3050_R01DetailList_Number = deletedMST3050_R01DetailList.map(value => Number(value));
		let processName = '';
		let newDetailList: MST3050_R01DetailDto[] = [];
		let newHeaderList: MST3050_R01HeaderDto[] = [];
		let responseData: MST3050_R01Dto = {
			itemHeaderDto: selectedMST3050_R01!,
			xyCoordinateDetailDtoList: MST3050_R01DetailList
		};

		try {
			
			if (selectedMST3050_R01) {
				newDetailList = MST3050_R01DetailList.filter(value => 
					!deletedMST3050_R01DetailList_Number.includes(value.valueIndex)
				);

				if (newDetailList.length === 0) {
					processName = 'delete';
					const deleteResponse = await deleteMST3050_R01(selectedMST3050_R01.itemCd);

					newHeaderList = MST3050_R01List.filter(value => value.itemCd !== selectedMST3050_R01.itemCd);

					if (deleteResponse && deleteResponse.data) {
						if (deleteResponse.data.successFlag) {
							showSuccess('실장좌표정보 삭제가 성공하였습니다.');
							setMessage('실장좌표정보 삭제가 성공하였습니다.');
						}else return;
					}
				} else {
					processName = 'patch';

						const patchResponse = await patchMST3050_R01({
							itemHeaderDto: selectedMST3050_R01!,
							xyCoordinateDetailDtoList: setInfoDetailList(selectedMST3050_R01!, newDetailList)
						});

						if (patchResponse?.data?.data?.[0] && patchResponse.data.successFlag) {
							responseData = patchResponse.data.data[0];
							newHeaderList = MST3050_R01List.map(value => {
								if (value.itemCd === responseData.itemHeaderDto.itemCd) {
									return responseData.itemHeaderDto;
								}
								return value;
							});
							
							showSuccess('실장좌표정보 수정에 성공하였습니다.');
							setMessage('실장좌표정보 수정에 성공하였습니다.');
						}
				}
			}
			
		} catch (error: any) {
			console.log('error :', error.response?.data?.message || error.message);
			showError(error.response?.data?.message || '실장좌표정보 작업 중 오류가 발생했습니다.');
			return;
		}


		if (processName === 'delete') {
			setMST3050_R01List(newHeaderList);
			setSelectedMST3050_R01(undefined);
			setMST3050_R01DetailList([]);
			handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			setMST3050_R01List(newHeaderList);
			setMST3050_R01DetailList(responseData.xyCoordinateDetailDtoList);
			setSelectedMST3050_R01(responseData.itemHeaderDto);
			setOriginalMST3050_R01DetailList(responseData.xyCoordinateDetailDtoList);
		}

		// setSelectedMST3050_R01(undefined);
		setDeletedMST3050_R01DetailList([]);
		setSelectedMST3050_R01DetailList([]); // 저장 후 상세행 선택 상태 초기화
		setTimeout(() => {
			setMessage('');
		}, 5000)
	
	}, [
		MST3050_R01List, setMST3050_R01List,
		selectedMST3050_R01, 
		editMST3050_R01, 
		MST3050_R01DetailList, 
		deletedMST3050_R01DetailList, 
	])

	// 발주내역 상세조회
	useEffect(() => {
		if (!detailFetchTrigger || !selectedMST3050_R01?.itemCd) return;
		fetchDetailList(selectedMST3050_R01.itemCd);
		setDetailFetchTrigger(false);
	}, [detailFetchTrigger, selectedMST3050_R01, fetchDetailList, setDetailFetchTrigger]);

	useEffect(() => {
		if (selectedMST3050_R01 && MST3050_R01DetailList.length === 0) {
			insertMST3050_R01DetailList([{ ...defaultMST3050_R01DetailRow(), inserted: true }]);
		}
	}, [selectedMST3050_R01, MST3050_R01DetailList])
	
	return {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultMST3050_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	};
}
